/**
 * Gibt einen in das lokale Format (de-DE) umgewandelten Zahlenwert als string zurück
 */
export function numberformat(value: number | undefined) {
  if (value !== undefined) {
    return value.toLocaleString('de-DE');
  }
  return undefined;
}

/**
 * Gibt einen in das lokale Format (de-DE) umgewandelten Zahlenwert mit fester Anzahl Nachkommastellen als string zurück
 */
export function numberformatFixed(value: number | undefined, fractionDigits: number) {
  if (value !== undefined) {
    return value.toLocaleString('de-DE', {minimumFractionDigits: fractionDigits});
  }
  return undefined;
}

/**
 * Formatiert Geldbeträge in das lokale Format (de-DE) und limitert auf max. zwei Nachkommastellen
 * Notwendig, weil wir in der DB oft Fließkommazahlen
 */
export function numberformatMoney(value: number | null) {
  if (value !== null) {
    return value.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utils/numberformat.ts